import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export var ReasonForOverride;
(function (ReasonForOverride) {
    ReasonForOverride["NotSet"] = "NotSet";
    ReasonForOverride["MissingRequiredCourse"] = "MissingRequiredCourse";
})(ReasonForOverride || (ReasonForOverride = {}));
export class UserLimitationResource extends BaseResource {
    pk() {
        return "all";
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: Infinity
        };
    }
    static url() {
        return this.urlRoot;
    }
}
UserLimitationResource.urlRoot = legacyApiResourceUrl("VulcanData/UserLimitations");
//# sourceMappingURL=UserLimitationsResource.js.map